module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-06.0d13a84a.png";